import "core-js/modules/es6.array.map";
import React from 'react';
import styled from 'styled-components';
import Scroll from 'react-scroll-to-element';
var ChapterList = styled.ul.withConfig({
  displayName: "Chapters__ChapterList",
  componentId: "sc-1e3ja9b-0"
})(["display:block;max-width:700px;margin:0 auto 0 auto;line-height:55px;padding:100px 0;position:relative;&:before{position:absolute;content:'';height:100%;width:200vw;left:-100vw;top:0;background-color:", ";}@media screen and (max-width:800px){padding:20px 0 20px 0;&:before{height:calc(100%);}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.chapterSelectBackgroundColor;
});
var ChapterItem = styled.li.withConfig({
  displayName: "Chapters__ChapterItem",
  componentId: "sc-1e3ja9b-1"
})(["display:block;width:100%;padding:0;list-style-type:none;margin:40px 0;position:relative;transition:all 0.3s linear;-webkit-transition:all 0.3s linear;color:", ";font-size:42px;line-height:55px;text-align:center;font-family:", ";font-weight:", ";text-transform:", ";a{text-decoration:none;color:", ";position:relative;transition:all 0.1s linear;-webkit-transition:all 0.1s linear;background-image:none;}&:before{content:'", "';position:absolute;top:0;left:50%;transform:translateX(-50%);color:", ";opacity:0.3;font-size:90px;transition:all 0.1s linear;-webkit-transition:all 0.1s linear;}&:hover,&:active{&:before{font-size:100px;color:", ";opacity:1;}}@media screen and (max-width:800px){font-size:24px;line-height:35px;margin:20px 0;&:before{font-size:40px;}&:hover,&:active{&:before{font-size:60px;}}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.chapterSelectItemColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.headerFontFamily;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.headerFontWeight || 'bold';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.uppercaseTitles ? 'uppercase' : 'none';
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.chapterSelectItemColor;
}, function (props) {
  return props.index + 1;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.chapterSelectItemNumberColor;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.chapterSelectItemNumberColor;
});
export default (function (_ref9) {
  var chapters = _ref9.chapters;
  return React.createElement(ChapterList, {
    id: "chapter-list"
  }, chapters.map(function (chapter, i) {
    return React.createElement(Scroll, {
      type: "id",
      element: chapter.id,
      key: "chapter-item-" + chapter.id
    }, React.createElement(ChapterItem, {
      index: i
    }, React.createElement("a", {
      href: ""
    }, chapter.title)));
  }));
});